import { React, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  RightLayoutContainer,
  PageTitleComp,
  TableLayoutData,
} from "../../styledElements";
import {
  Button,
  PageHeader,
  Table,
  Tooltip,
  Progress,
  Tabs,
  Row,
  Col,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import { Styled, StyledTab } from "../../pageStyled";
import { getStockRecords } from "../../../Services/stockManagementService";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import moment from "moment";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import EmptyState from "../../../Components/EmptyState/emptyState";
import {
  currency_List,lengthUnit,weightUnit 
  } from "../../../Utils/Constant/MeasurementUnitList.jsx";

const Panes = Tabs.TabPane;
const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);
const StockRecords = (props) => {
  const [tableParams, setTableParams] = useState({
    sort_by: "created_at",
    sort_type: "descending",
    page: 1,
    size: 10,
  });
  const [stockRecords, setStockRecords] = useState([]);
  const [stockState, setStockState] = useState("");
  const [rendering, setRendering] = useState(true);
  const [totalRecords, setTotalRecords] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [clearSearch, setClearSearch] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [filterTags, setFilterTags] = useState([]);
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const paginationRef = useRef({
    sort_by: "created_at",
    sort_type: "descending",
    page: 1,
    size: 10
  });
  const titleRef = useRef(null);
  const tabRef = useRef(null);
  const [stickyOffsets, setStickyOffsets] = useState({ title: 58, tabs: 95, table: 140 });

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      const baseTop = 58;
      const titleHeight = titleRef.current?.offsetHeight || 0;
      const tabsHeight = tabRef.current?.offsetHeight || 0;

      setStickyOffsets({
        title: baseTop,
        tabs: baseTop + titleHeight,
        table: baseTop + titleHeight + tabsHeight
      });
    });

    if (titleRef.current) observer.observe(titleRef.current);
    if (tabRef.current) observer.observe(tabRef.current);

    return () => observer.disconnect();
  }, [rendering]);

  const columnsAllStocksHead = useRef([
    {
      title: "Stock No.",
      dataIndex: "id",
      width: "5%",
      fixed: "left",
      key: "stockno",
      align: "left",
      sorter: {
        compare: (a, b) => a.id && b.id && a.id - b.id
      },
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      width: "6%",
      sorter: {
        compare: (a, b) => new Date(a.created_at) - new Date(b.created_at)
      },
      align: "left",
    },
    {
      title: "Size",
      dataIndex: "size",
      width: "5%",
      align: "left",
    },
    {
      title: "Ply",
      dataIndex: "ply",
      width: "5%",
      align: "left",
    },
    {
      title: "Grain",
      dataIndex: "grain",
      width: "6%",
      align: "left",
    },
    {
      title: "Product Code",
      dataIndex: "product",
      width: "4.5%",
      align: "left",
    },
    {
      title: "Product Spec",
      dataIndex: "product_spec",
      width: "7%",
      align: "left",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "4%",
      align: "left",
    },
    {
      title: "WIP Quantity",
      dataIndex: "quantity",
      width: "5%",
      align: "left",
    },
    {
      title: "WIP Weight",
      dataIndex: "weight",
      width: "4%",
      align: "left",
    },
    {
      title: "Cancelled Quantity",
      dataIndex: "cancelled_quantity",
      width: "5%",
      align: "left",
    },
    {
      title: "Cancelled Weight",
      dataIndex: "cancelled_weight",
      width: "5%",
      align: "left",
    },
    {
      title: "Produced Quantity",
      dataIndex: "produced_quantity",
      width: "5%",
      align: "left",
    },
    {
      title: "Produced Weight",
      dataIndex: "produced_weight",
      width: "5%",
      align: "left",
    },
    {
      title: "Accepted Produced Quantity",
      dataIndex: "accepted_produced_quantity",
      width: "5%",
      align: "left",
    },
    {
      title: "Accepted Produced Weight",
      dataIndex: "accepted_produced_weight",
      width: "5%",
      align: "left",
    },
    {
      title: "Rejected Produced Quantity",
      dataIndex: "rejected_produced_quantity",
      width: "5%",
      align: "left",
    },
    {
      title: "Rejected Produced Weight",
      dataIndex: "rejected_produced_weight",
      width: "5%",
      align: "left",
    },
    {
      title: "Reel OD",
      dataIndex: "reel_od",
      width: "4%",
      align: "left",
    },
    {
      title: "Core OD",
      dataIndex: "core_id",
      width: "4%",
      align: "left",
    },
    {
      title: "Job Card No.",
      dataIndex: "jc_code",
      width: "10%",
      align: "left",
    },
    {
      title: "Created By",
      dataIndex: "created_by",
      width: "7%",
      align: "left",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: "5.8%",
      align: "center",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.status === "In Progress"
                  ? "The stock is in progress"
                  : record.status === "Cancelled"
                  ? "The stock is cancelled"
                  : record.status === "Produced"
                  ? "The stock quantity is produced"
                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {" "}
              {record.status}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
  ]);

  const columnsWorkInProgressStocksHead = useRef([
    {
      title: "Stock No.",
      dataIndex: "id",
      width: "5%",
      fixed: "left",
      key: "stockno",
      align: "left",
      sorter: {
        compare: (a, b) => a.id && b.id && a.id - b.id
      },
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      width: "6%",
      sorter: {
        compare: (a, b) => new Date(a.created_at) - new Date(b.created_at)
      },
    },
    {
      title: "Size",
      dataIndex: "size",
      width: "6%",
      align: "left",
    },
    {
      title: "Ply",
      dataIndex: "ply",
      width: "5%",
      align: "left",
    },
    {
      title: "Grain",
      dataIndex: "grain",
      width: "5%",
      align: "left",
    },
    {
      title: "Product Code",
      dataIndex: "product",
      width: "4.5%",
      align: "left",
    },
    {
      title: "Product Spec",
      dataIndex: "product_spec",
      width: "7%",
      align: "left",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "4%",
      align: "left",
    },
    {
      title: "WIP Quantity",
      dataIndex: "quantity",
      width: "5%",
      align: "left",
    },
    {
      title: "WIP Weight",
      dataIndex: "weight",
      width: "5%",
      align: "left",
    },
    {
      title: "Reel OD",
      dataIndex: "reel_od",
      width: "4%",
      align: "left",
    },
    {
      title: "Core OD",
      dataIndex: "core_id",
      width: "4%",
      align: "left",
    },
    {
      title: "Job Card No.",
      dataIndex: "jc_code",
      width: "10%",
      align: "left",
    },
    {
      title: "Created By",
      dataIndex: "created_by",
      width: "7%",
      align: "left",
    },
  ]);

  const columnsProducedHead = useRef([
    {
      title: "Stock No.",
      dataIndex: "id",
      width: "5%",
      fixed: "left",
      key: "stockno",
      align: "left",
      sorter: {
        compare: (a, b) => a.id && b.id && a.id - b.id
      },
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      width: "6%",
      sorter: {
        compare: (a, b) => new Date(a.created_at) - new Date(b.created_at)
      },
    },
    {
      title: "Size",
      dataIndex: "size",
      width: "6%",
      align: "left",
    },
    {
      title: "Ply",
      dataIndex: "ply",
      width: "5%",
      align: "left",
    },
    {
      title: "Grain",
      dataIndex: "grain",
      width: "5%",
      align: "left",
    },
    {
      title: "Product Code",
      dataIndex: "product",
      width: "4.5%",
      align: "left",
    },
    {
      title: "Product Spec",
      dataIndex: "product_spec",
      width: "7%",
      align: "left",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "4%",
      align: "left",
    },
    {
      title: "Cancelled Quantity",
      dataIndex: "cancelled_quantity",
      width: "5%",
      align: "left",
    },
    {
      title: "Cancelled Weight",
      dataIndex: "cancelled_weight",
      width: "5%",
      align: "left",
    },
    {
      title: "Produced Quantity",
      dataIndex: "produced_quantity",
      width: "5%",
      align: "left",
    },
    {
      title: "Produced Weight",
      dataIndex: "produced_weight",
      width: "5%",
      align: "left",
    },
    {
      title: "Accepted Quantity",
      dataIndex: "accepted_produced_quantity",
      width: "5%",
      align: "left",
    },
    {
      title: "Accepted Weight",
      dataIndex: "accepted_produced_weight",
      width: "5%",
      align: "left",
    },
    {
      title: "Rejected Quantity",
      dataIndex: "rejected_produced_quantity",
      width: "5%",
      align: "left",
    },
    {
      title: "Rejected Weight",
      dataIndex: "rejected_produced_weight",
      width: "5%",
      align: "left",
    },
    {
      title: "Reel OD",
      dataIndex: "reel_od",
      width: "4%",
      align: "left",
    },
    {
      title: "Core OD",
      dataIndex: "core_id",
      width: "4%",
      align: "left",
    },
    {
      title: "Job Card No.",
      dataIndex: "jc_code",
      width: "10%",
      align: "left",
    },
    {
      title: "Created By",
      dataIndex: "created_by",
      width: "7%",
      align: "left",
    },
  ]);

  const columnsCancelledStocksHead = useRef([
    {
      title: "Stock No.",
      dataIndex: "id",
      width: "5%",
      fixed: "left",
      key: "stockno",
      align: "left",
      sorter: {
        compare: (a, b) => a.id && b.id && a.id - b.id
      },
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      width: "6%",      
      sorter: {
        compare: (a, b) => new Date(a.created_at) - new Date(b.created_at)
      },
    },
    {
      title: "Size",
      dataIndex: "size",
      width: "6%",
      align: "left",
    },
    {
      title: "Ply",
      dataIndex: "ply",
      width: "5%",
      align: "left",
    },
    {
      title: "Grain",
      dataIndex: "grain",
      width: "5%",
      align: "left",
    },
    {
      title: "Product Code",
      dataIndex: "product",
      width: "4.5%",
      align: "left",
    },
    {
      title: "Product Spec",
      dataIndex: "product_spec",
      width: "7%",
      align: "left",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "4%",
      align: "left",
    },
    {
      title: "Cancelled Quantity",
      dataIndex: "cancelled_quantity",
      width: "5%",
      align: "left",
    },
    {
      title: "Cancelled Weight",
      dataIndex: "cancelled_weight",
      width: "5%",
      align: "left",
    },
    {
      title: "Reel OD",
      dataIndex: "reel_od",
      width: "4%",
      align: "left",
    },
    {
      title: "Core OD",
      dataIndex: "core_id",
      width: "4%",
      align: "left",
    },
    {
      title: "Job Card No.",
      dataIndex: "jc_code",
      width: "10%",
      align: "left",
    },
    {
      title: "Created By",
      dataIndex: "created_by",
      width: "7%",
      align: "left",
    },
  ]);

  const tabHeads = [
    {
      key: 0,
      title: "All Stocks",
      state: "",
      header: columnsAllStocksHead.current,
    },
    {
      key: 1,
      title: "Work In Progress",
      state: "progress",
      header: columnsWorkInProgressStocksHead.current,
    },
    {
      key: 2,
      title: "Produced",
      state: "produced",
      header: columnsProducedHead.current,
    },
    {
      key: 3,
      title: "Cancelled",
      state: "cancelled",
      header: columnsCancelledStocksHead.current,
    },
  ];

  const refresh  = () => {
    setLoading(true);
    setStockRecords();
    setSearchValue("");
    setClearSearch(true);
    setRendering(true);
  }
  const searchStocks = async (value = "") => {
    setSearchValue(value);
  };
  const fetchStockList = async (params, sort, state) => {
    try {
    } catch (error) {
      console.log(error);
    }
  };
  const exportHandler = () => {};

  const applyfilter = (filter) => {};

  const formatFilters = (item) => {
    console.log("Item in format", item);
  };

  const removeFilter = (filter) => {};

  const onChange = (pagination, filters, sorter, extra, orderState) => {
    setLoading(true);
    if(stockState === ""){
      columnsAllStocksHead.current?.map((item) => {
      if(item.dataIndex !== sorter?.field){
        item["sortOrder"] = null;
      } 
      if (item.dataIndex == sorter?.field) {
        item["sortOrder"] = sorter ? sorter.order : "";
      }
    });
    }
    if(stockState === "progress"){
      columnsWorkInProgressStocksHead.current?.map((item) => {
      if(item.dataIndex !== sorter?.field){
        item["sortOrder"] = null;
      } 
      if (item.dataIndex == sorter?.field) {
        item["sortOrder"] = sorter ? sorter.order : "";
      }
    });
    }
    if(stockState === "produced"){
      columnsProducedHead.current?.map((item) => {
      if(item.dataIndex !== sorter?.field){
        item["sortOrder"] = null;
      } 
      if (item.dataIndex == sorter?.field) {
        item["sortOrder"] = sorter ? sorter.order : "";
      }
    });
    }
    if(stockState === "cancelled"){
      columnsCancelledStocksHead.current?.map((item) => {
      if(item.dataIndex !== sorter?.field){
        item["sortOrder"] = null;
      } 
      if (item.dataIndex == sorter?.field) {
        item["sortOrder"] = sorter ? sorter.order : "";
      }
    });
    }
    const tempSort = sorter.order === "ascend" ? "ascending" : "descending";
    if (
      sorter.field &&
      (paginationRef.current.sort_type !== tempSort ||
        paginationRef.current.sort_by !== sorter.field)
    ) {
      setClearSearch(true);
      setCurrentPage(1);
      setTableParams({
        ...tableParams,
        page: 1,
        size: pagination.pageSize,
        sort_by: sorter.field,
        sort_type: tempSort,
      });
      paginationRef.current = {
        ...tableParams,
        page: 1,
        size: pagination.pageSize,
        sort_by: sorter.field,
        sort_type: tempSort,
      };
    } else {
      setCurrentPage(pagination.current);
      setTableParams({
        ...tableParams,
        page: pagination.current,
        size: pagination.pageSize,
        sort_by: sorter.field || tableParams.sort_by,
        sort_type: tempSort,
      });
      paginationRef.current = {
        ...tableParams,
        page: pagination.current,
        size: pagination.pageSize,
        sort_by: sorter.field || tableParams.sort_by,
        sort_type: tempSort,
      };
    }
  };
  const handleTabChange = (key) => {
    if(stockState === ""){
    columnsAllStocksHead.current?.map((item) => {
      item["sortOrder"] = null;
    });
    }
    if(stockState === "progress"){
      columnsWorkInProgressStocksHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if(stockState === "produced"){
      columnsProducedHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if(stockState === "cancelled"){
      columnsCancelledStocksHead.current?.map((item) => {
        item["sortOrder"] = null;
    });
    }
    setLoading(true);
    setSearchValue("");
    setClearSearch(true);
    setStockState(tabHeads[key].state);
    setTableParams({
      sort_by: "created_at",
      sort_type: "descending",
      page: 1,
      size: 10,
      status: tabHeads[key].state,
    });
    // setAppliedFilters([]);

    setCurrentPage(1);

    setRendering(true);
  };

  const getJCCode = (str) => {
    if(str){
      let splittedString = str?.split("~");
      let mergeString;
      mergeString = splittedString?.join("");
      return mergeString;
    }
  };

  useEffect(() => {
    let propsData = {};
    if(emptyStateLabel === "noData"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records in this list";
      propsData["subHeading"] = "There are no records to show in this list. Add your first record to view details here";
    } else if(emptyStateLabel === "search"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] = "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
    } else if(emptyStateLabel === "filter"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] = "There is no record matching your filter. Try changing your filter to find what you are looking for.";
    } else {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "Something went wrong";
      propsData["subHeading"] = "Check your internet connection or try reloading the page.";
    }
    setEmptyStatePropsData(propsData);
  },[emptyStateLabel]);

  useEffect(() => {
    if(rendering){
      setRendering(false);
    }
    getStockRecords(paginationRef.current,stockState)
      .then((response) => {
        if (response) {
            if(!response.data.data.stocks.length){
              setEmptyStateLabel("noData");
            }
          //console.log(response);
          const list = response.data.data.stocks.map((stock) => {
            let formattedNo = getJCCode(stock.jobcard_code);
            return {
              ...stock,
              created_at: stock.created_at
                ? moment(stock.created_at).format("DD MMM YYYY")
                : "-",
              size: `${stock.width}${
                stock.length ? `x${stock.length}` : ""
              } CM`,
              //quantity: item.quantity,
              grain: stock.grain? capitalize(stock.grain) : "-",
              jc_code: formattedNo,
              core_id: stock.core_id? `${stock.core_id} ${stock.units? lengthUnit[stock.units?.core_id].displayName.toUpperCase() : 'CM'}` : "-",
              reel_od: stock.reel_od? `${stock.reel_od} ${stock.units? lengthUnit[stock.units?.reel_od].displayName.toUpperCase() : 'CM'}` : "-", 
              type: capitalize(stock.type),
              produced_weight: stock.produced_weight !== 0 ?`${stock.produced_weight.toFixed(3)} ${stock.units? capitalize(weightUnit[stock.units?.weight].displayName) : 'T'}`:'-',
              produced_quantity: stock.produced_quantity !== 0 ?`${stock.produced_quantity} ${capitalize(stock.type)}s`:'-',
              weight: stock.weight !== 0 ?`${stock.weight.toFixed(3)} ${stock.units? capitalize(weightUnit[stock.units?.weight].displayName) : 'T'}`:'-',
              quantity: stock.quantity !== 0 ?`${stock.quantity} ${capitalize(stock.type)}s`:'-',
              accepted_produced_weight: stock.accepted_produced_weight !== 0 ?`${stock.accepted_produced_weight.toFixed(3) } ${stock.units? capitalize(weightUnit[stock.units?.weight].displayName) : 'T'}`:'-',
              accepted_produced_quantity: stock.accepted_produced_quantity !== 0 ?`${stock.accepted_produced_quantity} ${capitalize(stock.type)}s`:'-',
              rejected_produced_weight: stock.rejected_produced_weight !== 0 ?`${stock.rejected_produced_weight.toFixed(3)} ${stock.units? capitalize(weightUnit[stock.units?.weight].displayName) : 'T'}`:'-',
              rejected_produced_quantity: stock.rejected_produced_quantity !== 0 ?`${stock.rejected_produced_quantity} ${capitalize(stock.type)}s`:'-',
              cancelled_weight: stock.cancelled_weight !== 0 ?`${stock.cancelled_weight.toFixed(3)} ${stock.units? capitalize(weightUnit[stock.units?.weight].displayName) : 'T'}`:'-',
              cancelled_quantity: stock.cancelled_quantity !== 0 ?`${stock.cancelled_quantity} ${capitalize(stock.type)}s`:'-',
              status : stock.status === "progress" ? "In Progress" : stock.status === "produced" ? "Produced" : "Cancelled",
              ply : stock.ply,
            };
          });
          setStockRecords(list);
          setTotalRecords(response.data.data.total_stocks);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        setEmptyStateLabel("connectionAPIError");
      });
  }, [tableParams, rendering]);
  return  (
      <RightLayoutContainer id="right-layout-container">
        <style dangerouslySetInnerHTML={{
          __html: `
          .ant-tabs, .ant-tabs-content-holder, .ant-tabs-content, .ant-tabs-tabpane {
            overflow: visible !important;
          }
          .ant-table-sticky-holder {
            z-index: 101 !important;
          }
          .tableDataFormat table colgroup col {
            min-width: 100px !important;
          }
        `}} />
        <PageTitleComp ref={titleRef} style={{ borderBottom: "0", position: "sticky", top: stickyOffsets.title, zIndex: 100, backgroundColor: "#fff", paddingBottom: "10px" }}>
          <PageHeader ghost={false} title="Stock Records"></PageHeader>
      </PageTitleComp>
      <TableLayoutData>
        <div className="tableDataFormat">
          <StyledTab>
            <Tabs
              defaultActiveKey="0"
              onChange={handleTabChange}
              destroyInactiveTabPane={true}
              renderTabBar={(props, DefaultTabBar) => (
                <div ref={tabRef} style={{ position: "sticky", top: stickyOffsets.tabs, zIndex: 99, background: "#fff" }}>
                  <DefaultTabBar {...props} />
                </div>
              )}
            >
              {tabHeads.map((tab) => (
                <Panes tab={tab.title} key={tab.key}>
                  {/* <SearchContainer
                    placeholder={"Search Stock Number"}
                    fetchOrder={searchStocks}
                    exportRole={true}
                    exportTrigger={exportHandler}
                    clearSearch={clearSearch}
                    setClearSearch={setClearSearch}
                    searchedValue={searchValue}
                    filterOptions={[
                      {
                        key: 0,
                        label: "Filter by Created Date",
                        value: "created_date",
                        type: "date",
                      },
                      {
                        key: 1,
                        label: "Filter by Size",
                        value: "size",
                        type: "date",
                      },
                      {
                        key: 2,
                        label: "Filter by Product",
                        value: "product",
                        type: "multiSelect",
                      },
                      {
                        key: 3,
                        label: "Filter by Grade/Quality",
                        value: "grade_quality",
                        type: "grade",
                      },
                      {
                        key: 4,
                        label: "Filter by GSM",
                        value: "gsm",
                        type: "inputSelect",
                      },
                      {
                        key: 5,
                        label: "Filter by Burst Factor",
                        value: "burst_factor",
                        type: "inputSelect",
                      },
                      {
                        key: 6,
                        label: "Filter by Reel OD",
                        value: "reel_od",
                        type: "inputSelect",
                      },
                      {
                        key: 7,
                        label: "Filter by Core ID",
                        value: "core_id",
                        type: "inputSelect",
                      },
                      {
                        key: 8,
                        label: "Filter by Type",
                        value: "type",
                        type: "inputSelect",
                      },
                      {
                        key: 9,
                        label: "Filter by Job Card No.",
                        value: "jobcard",
                        type: "input",
                      },
                    ]}
                    applyFilter={applyfilter}
                  />
                  {filterTags.map((filter) => (
                    // <Tooltip
                    //   placement="bottomRight"
                    //   title={filter.tooltip || ""}
                    //   className="edit-tooltip"
                    //   getPopupContainer={(triggerNode) => triggerNode}
                    // >
                    <span className="filter-tags">
                      <Iconmoon icon="filter" size={13} color="#a8a8a8" />
                      &nbsp;
                      <span>{filter.formattedType}</span>
                      &nbsp;
                      <span>{filter.operand}</span>
                      &nbsp;
                      <span>{filter.value}</span>
                      <span>
                        {" "}
                        <button
                          onClick={() => {
                            removeFilter(filter);
                          }}
                        >
                          {" "}
                          <Iconmoon
                            icon="wrong"
                            size={15}
                            color="#a8a8a8"
                          />{" "}
                        </button>
                      </span>
                      <Styled></Styled>
                    </span>
                    // </Tooltip>
                  ))} */}

                   { loading ? (
                    <TableShimmer
                      header = {tab.header}
                      scroll = {2000}
                    />
                  ) : stockRecords?.length ? (
                  <Table
                    columns={tab.header}
                    dataSource={stockRecords}
                    onChange={onChange}
                    // pageSize={3}
                    pagination={{
                      current: currentPage,
                      total: totalRecords,
                      showTitle: false,
                      pageSize: paginationRef.current.size,
                      showTotal: (total, range) =>
                        `Showing ${range[0]}-${range[1]} of ${total} results`,
                      pageSizeOptions: [10, 20, 50, 100],
                      showSizeChanger: true,
                      // locale: { items_per_page: "" },
                    }}
                    scroll={{ x: "max-content" }}
                    sticky={{
                      offsetHeader: stickyOffsets.table,
                      getContainer: () => {
                        let node = document.getElementById('right-layout-container');
                        while (node && node !== document.body) {
                          const style = window.getComputedStyle(node);
                          if (style.overflowY === 'auto' || style.overflowY === 'scroll') return node;
                          node = node.parentNode;
                        }
                        return window;
                      }
                    }}
                    rowClassName={(record) => record.priority && "true"}
                  />
                  ) : (
                    <EmptyState
                      img= {emptyStateLabel === "noData" || emptyStateLabel === "filter" ? emptyState_NoData : 
                      emptyStateLabel === "search" ? emptyState_Search : 
                      emptyState_ConnectionAPIError}
                      heading= {emptyStatePropsData.heading}
                      subHeading= {emptyStatePropsData.subHeading}
                      label={emptyStatePropsData.label}
                      refresh={refresh}
                      />
                  )}
                </Panes>
              ))}
            </Tabs>
          </StyledTab>
        </div>
      </TableLayoutData>
    </RightLayoutContainer>
  );
};

export default StockRecords;
